<ng-container *ngIf="opened">
  <kendo-dialog class="postal-address-modal" [title]="referenceDataLabels.FindAddressId|localizeLabel" (close)="close()">
    <div class="inner-container vo-list-view-inner-container">
      <div class="addresses-list">
        <div class="bo-info-text vo-address-item" *ngFor="let address of addresses" (click)="select(address)"
          [ngClass]="{'selected-item': selected === address}">
          {{address.AddressLine1}} {{address.AddressLine2}} {{address.AddressLine3}} {{address.County}}
        </div>
      </div>
    </div>

    <kendo-dialog-actions class="modal-buttons">
      <label (click)="close()" [innerHtml]="referenceDataLabels.CancelId | localizeLabel"
        class="link vo-secondary-button-1 mb-15 mb-md-0"></label>

      <button class="primary-button vo-primary-button-1" (click)="confirm()"
        [innerHtml]="referenceDataLabels.SelectAddress | localizeLabel" [ngClass]="{'disabled': !selected}"
        [disabled]="!selected"></button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
